import React from 'react'
import { Flex, Box, Heading, Text } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { get } from 'lodash'

import RealTimeCard from './RealTimeCard'

const RealTimeSection = () => {
  const { t } = useTranslation('home')
  const images = useStaticQuery(graphql`
    query {
      live_chat: file(relativePath: { eq: "home/live_chat.svg" }) {
        publicURL
      }
      live_blog: file(relativePath: { eq: "home/live_blog.svg" }) {
        publicURL
      }
      content_wall: file(relativePath: { eq: "home/content_wall.svg" }) {
        publicURL
      }
    }
  `)

  const liveChat = get(images, 'live_chat.publicURL')
  const liveBlog = get(images, 'live_blog.publicURL')
  const contentWall = get(images, 'content_wall.publicURL')

  return (
    <Flex
      as="section"
      justifyContent={['center', 'center', 'space-between']}
      alignItems={['center', 'center', 'flex-start']}
      flexDirection={['column', 'column', 'row-reverse']}
      maxWidth="container"
      mx="auto"
      pt={[11, 11, 32]}
      px={[5, 5, 0]}
      pb={30}
      sx={{
        position: 'relative'
      }}
    >
      <Box
        flex={[1, 1, '0 48%']}
        alignSelf="flex-start"
        width={[1, '70%']}
        sx={{
          '@media (max-width: 32rem)': {
            borderBottom: '0.5px solid',
            borderBottomColor: 'rgba(222, 222, 222, 0.8)'
          }
        }}
      >
        <Heading
          mb={6}
          variant="level2"
          lineHeight="122%"
          sx={{
            '@media (min-width: 80rem)': {
              fontSize: '45px'
            }
          }}
        >
          {t('real_time.title')}
        </Heading>

        <Text mb={[10, 12, 0]} variant="level5">
          {t('real_time.subtitle')}
        </Text>
      </Box>

      <Flex
        flex={[1, 1, '0 48%']}
        flexDirection="column"
        alignItems={['flex-start', 'center', 'flex-start']}
      >
        <Link to={'/products/live-chat'}>
          <RealTimeCard src={liveChat} type="live-chat" mb={10} />
        </Link>

        <Link to={'/products/live-blog'}>
          <RealTimeCard
            type="live-blog"
            src={liveBlog}
            mb={[10, 10, 0]}
            css={{
              '@media (max-width: 32rem)': {
                boxShadow: '0px 30px 80px rgba(33, 47, 64, 0.1)',
                borderRadius: '10px'
              }
            }}
          />
        </Link>

        <Link to={'/products/content-wall'}>
          <RealTimeCard
            src={contentWall}
            type="content-wall"
            mb={[10, 10, 0]}
            css={{
              '@media (min-width: 80rem)': {
                position: 'absolute',
                right: '0',
                top: '519px'
              }
            }}
          />
        </Link>
      </Flex>
    </Flex>
  )
}

export default RealTimeSection
